export type image = {
    image: string,
    fileName: string,
    id: string,
    type: "fetched_image" | "new_image"
}

export type apiImage = {
    content: string,
    name: string,
    hash: string,
    type: string
}

export function partitionImages(images: apiImage[]): [image[], image[]] {
    function transformImage(image: apiImage): image {
        return {
            image: image.content,
            fileName: image.name,
            id: image.hash,
            type: "fetched_image"
        };
    }

    const stemImages = images
        .filter(image => image.type === "STEM")
        .map(transformImage);
    const explanationImages = images
        .filter(image => image.type === "EXPLANATION")
        .map(transformImage);

    return [stemImages, explanationImages];
}


export function getFileType(filename: string): string {
    return filename.split(".").pop() || "";
}

export function toDataUri(image: string, imageName: string) {
    return "data:image/" + getFileType(imageName) + ";base64," + image;
}
